import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function MountPositionModal({pageLanguage, modals, modalHandleClose, t}) {
  return (
   <Modal
   dialogClassName={`noInsideUnderstand_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["noInsideUnderstand"] === undefined ? false : modals["noInsideUnderstand"]}
   onHide={() => modalHandleClose("noInsideUnderstand")}
 >
   <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
   <Modal.Body>
     <p>{t("modal_select_mount")}</p>
     <div className=" text_center">
       <button
         className=" btn btn-new-dark"
         onClick={() => modalHandleClose("noInsideUnderstand")}
       >
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
